import React from 'react';

export default function IPadMockup() {
  return (
    <div className="w-full max-w-[860px] mx-auto px-4 sm:px-6 lg:px-8 mt-16 mb-32">
      {/* iPad Outer Frame */}
      <div className="relative mx-auto w-full bg-[#000000] rounded-[24px] sm:rounded-[36px] md:rounded-[48px] p-[10px] sm:p-[16px] md:p-[20px] shadow-[0_25px_50px_-12px_rgba(0,0,0,1)] ring-1 ring-[#27272A]">
        
        {/* Camera Dot */}
        <div className="absolute left-1/2 -translate-x-1/2 top-[2px] sm:top-[4px] md:top-[6px] w-[6px] h-[6px] sm:w-[8px] sm:h-[8px] rounded-full bg-[#1A1A1A] border border-[#27272A]/50 z-10"></div>

        {/* Inner Screen */}
        <div className="relative w-full bg-[#0D0D0D] rounded-[14px] sm:rounded-[20px] md:rounded-[28px] overflow-hidden border border-[#27272A]/20 flex items-center justify-center">
          <video 
            src="https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vbXA0/b1469c11532ddaff4d10ca7641cd73a3.mp4"
            className="w-full h-auto block"
            autoPlay
            loop
            muted
            playsInline
          />
        </div>
      </div>
    </div>
  );
}